const moment = require("moment");

function cleanUsageHistory({ usageList, serviceMap }) {
    try {
        if (!usageList) return;

        const results = {};

        for (let i = 0; i < usageList.length; i++) {
            const usage = usageList[i];
            const { serviceType, billDate } = usage;

            if (serviceMap[serviceType]) {
                const existingUsage = results[billDate];

                if (!existingUsage) {
                    results[billDate] = usage;
                } else {
                    // results[billDate] = addUsage({
                    //     initialUsage: existingUsage,
                    //     addition: usage,
                    // });
                }
            }
        }

        return results;
    } catch (e) {
        console.log(e);
    }
}

function addUsage({ initialUsage, addition }) {
    try {
        const chargeAmount =
            parseFloat(initialUsage.chargeAmount) +
            parseFloat(addition.chargeAmount);

        const meterDetails = [];

        for (let i = 0; i < initialUsage.meterDetails.length; i++) {
            const detail = initialUsage.meterDetails[i];
            meterDetails.push(detail);
        }

        for (let i = 0; i < addition.meterDetails.length; i++) {
            const detail = addition.meterDetails[i];
            meterDetails.push(detail);
        }

        const usageDetails = [];

        for (let i = 0; i < initialUsage.usageDetails.length; i++) {
            const usage = initialUsage.usageDetails[i];
            usageDetails.push(usage);
        }

        for (let i = 0; i < addition.usageDetails.length; i++) {
            const usage = addition.usageDetails[i];
            usageDetails.push(usage);
        }

        const results = { ...initialUsage };
        results.chargeAmount = chargeAmount.toFixed(2);
        results.meterDetails = meterDetails;
        results.usageDetails = usageDetails;

        return results;
    } catch (e) {
        console.log(e);
        return initialUsage;
    }
}

function createYearBasedUsageList({ usageMap }) {
    try {
        const results = {
            thisYearUsage: [],
            lastYearUsage: [],
        };

        if (!usageMap) return;

        const dates = findStartDate({ usageMap });

        if (!dates) return results;

        const { startDate, months } = dates;

        let currentDate = moment(startDate, "YYYY-MM");

        for (let i = 0; i < 12; i++) {
            const currentDateFormatted = currentDate.format("YYYY-MM");
            const monthUsage = months[currentDateFormatted];

            if (monthUsage) {
                const usageList = monthUsage.usageList;
                results.thisYearUsage = results.thisYearUsage.concat(usageList);
            }

            currentDate = currentDate.add(-1, "months");
        }

        for (let i = 0; i < 12; i++) {
            const currentDateFormatted = currentDate.format("YYYY-MM");
            const monthUsage = months[currentDateFormatted];

            if (monthUsage) {
                const usageList = monthUsage.usageList;
                results.lastYearUsage = results.lastYearUsage.concat(usageList);
            }

            currentDate = currentDate.add(-1, "months");
        }

        return results;
    } catch (e) {
        console.log(e);
        return { thisYearUsage: [], lastYearUsage: [] };
    }
}

function findStartDate({ usageMap }) {
    try {
        if (!usageMap) return;

        let currentDate = moment();

        const months = {};
        const keys = Object.keys(usageMap);

        for (let i = 0; i < keys.length; i++) {
            const date = keys[i];
            const month = moment(date, "YYYY-MM-DD").format("YYYY-MM");

            if (months[month]) {
                months[month].usageList.push(usageMap[date]);
            } else {
                months[month] = {
                    month,
                    usageList: [usageMap[date]],
                };
            }
        }

        for (let i = 0; i < 30; i++) {
            const currentDateFormatted = currentDate.format("YYYY-MM");

            if (months[currentDateFormatted]) {
                return { startDate: currentDateFormatted, months };
            }

            currentDate = currentDate.add(-1, "months");
        }

        return null;
    } catch (e) {
        console.log(e);
        return null;
    }
}

export { cleanUsageHistory, createYearBasedUsageList };
